module.exports = __webpack_public_path__ + "static/img_1676-828b627020fd75d4ad762345757b65f2.webp";